module.exports = __webpack_public_path__ + "img/about_blue.ef2ab2a5.png";